import { render } from "./WynikiWyszukiwaniaPage.vue?vue&type=template&id=f6b3927e&scoped=true"
import script from "./WynikiWyszukiwaniaPage.vue?vue&type=script&lang=js"
export * from "./WynikiWyszukiwaniaPage.vue?vue&type=script&lang=js"

import "./WynikiWyszukiwaniaPage.vue?vue&type=style&index=0&id=f6b3927e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b3927e"]])

export default __exports__